<template>
  <initio-panel @submit-handler="submitHandler" :errors="errors">
    <template v-slot:title>
      Get a quote
    </template>
    <template v-slot:before_form>
      <div v-if="!isLoggedIn" class="notification is-info-blue">
        <strong>Already have an account?</strong> <a href="/app/login?redirect=/spa/vehicle/new">Login, then add this policy</a>
      </div>
    </template>

    <template v-slot:form_bottom>
      <div class="recaptcha-wrapper" v-if="isNewPlateOrNoPlate">
        <vue-recaptcha
            :sitekey="appConfig.g_recapcha_v2_site_key"
            :loadRecaptchaScript="true"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
        ></vue-recaptcha>


      </div>
    </template>
    <template v-slot:after_form>
        <div class="tc-box">

          <h2>Your duty of disclosure</h2>
          <p>You must tell us all information you know (or could reasonably be expected to know) which would influence the judgement of a prudent underwriter whether or not to accept your application, and if it is accepted, on what terms and at what cost.</p>
          <h3>Examples of information you may need to disclose include:</h3>
          <ul>
            <li>anything that increases the risk of an insurance claim;</li>
            <li>any criminal convictions in the last 7 years or where imprisoned;</li>
            <li>if another insurer has cancelled or refused to renew insurance, or has imposed special terms;</li>
            <li>any insurance claim you have made in the past.</li>
          </ul>
          <h3>Examples of information you do not need to disclose include:</h3>
          <ul>
            <li>anything that reduces the risk of an insurance claim;</li>
            <li>anything we say you do not need to tell us about;</li>
            <li>anything that is common knowledge;</li>
            <li>anything you have already told us, or that we should be expected to know in the ordinary course of our business.</li>
          </ul>
          <p>These examples are a guide only. Please ask if you are not sure whether you need to tell us about something. All information will be treated confidentially.</p>
        </div>
    </template>
    <template v-slot:sidebar>
      <initio-dont-insure />
      <div v-if="isVueDevMode"  style="border: 2px dotted orange;" class="mt-2 p-3">
        <div class="is-size-7">VUE DEV MODE LOGIN HELPER</div>
        <span class="" v-if="isLoggedIn">Logged in as cli_num <strong>{{client.cli_num}}</strong></span><br />
        <span class="" v-if="! isLoggedIn">Currently not logged in</span>
        <hr class="mt-2 mb-0" />
        <div class="columns is-multiline mt-3">

          <div class="column is-12">
            <label>New cli_num </label>
            <input placeholder="cli_num" class="input" v-model="vueOverrideLoginCliNumInput" v-on:keyup.enter="vueDevForceUserLogin" />
          </div>
          <div class="column is-12">
            <div class="buttons">
              <a class="button" v-on:click="vueDevForceUserLogin">Force login</a> &nbsp;
              <a class="button is-light" v-if="isLoggedIn" v-on:click="vueDevForceUserLogout">Force logout</a>
            </div>
          </div>
          <div class="column is-12" v-if="vueOverrideLoginCliNumResult">
            {{vueOverrideLoginCliNumResult}}
          </div>
        </div>
      </div>
    </template>
  </initio-panel>
</template>

<script>
// Note the submit button is in the schema, so that we can keep the duty of disclosure in the schema ( below the continue button )

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioDontInsure from '@/components/partials/DontInsure.vue'
import stepSubmit from '@/mixins/stepSubmit.js'

import VueRecaptcha from 'vue-recaptcha';


import {mapGetters} from "vuex";
import axios from "axios";
import {api} from "@/store/store";
export default {
  components: {
    InitioPanel,
    InitioDontInsure,
    VueRecaptcha
  },
  mixins: [
    stepSubmit
  ],
  data () {
    return {
      errors: [],
      schema: [],
      recaptcha_token: null,
      vueOverrideLoginCliNumInput: null,
      vueOverrideLoginCliNumResult: null,
    }
  },
  computed: {
    isNewPlateOrNoPlate: function(){
      const vehiclePlatePageData = this.answers['Vehicle.Plate'];
      return !vehiclePlatePageData.vehicle_plate || (vehiclePlatePageData.vehicle_plate !== vehiclePlatePageData.vehicle_plate_confirm);
    },
    isVueDevMode: function(){
      return process.env.NODE_ENV === 'development'
    },
    ...mapGetters({
      answers: 'flattenedAnswers',
      client: 'client',
      isLoggedIn: 'isLoggedIn',
      appConfig: 'getAppConfig'
    })
  },
  methods: {
    onVerify: function (response) {
      this.recaptcha_token = response;
    },
    onExpired: function () {
      console.log('has expired, should reset');
      this.$refs.recaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
    submitHandler() {
      let context = this;

      // uppercase the plate on submit
      this.$store.commit('setAnswer',{
        step: 'Vehicle.Plate',
        answer: 'vehicle_plate',
        value: this.answers['Vehicle.Plate'].vehicle_plate.toUpperCase() // Painful making it uppercase within the component, so do it here
      });

      if( this.isNewPlateOrNoPlate && ! this.recaptcha_token ){
        context.errors = ["Please confirm you are not a robot and try again"];
        return;
      }

      // Validate the plate on the backend
      this.$store.commit('setPageLoading', true);
      this.$store.dispatch('getPlate', { plate: this.answers['Vehicle.Plate'].vehicle_plate, recaptcha_token: this.recaptcha_token })
        .then(response => {
          this.$store.commit('setPageLoading', false);
          this.genericSubmitHandler()
          .then(response => {
            // console.log("RESPONSE", response)
          }, error => {
            context.errors = error;
          });
        }, error => {
          this.$store.commit('setPageLoading', false);
            context.errors = error;
        })
    },

    async vueDevForceUserLogin(){
      try {
        const response = await axios.get(api.url + api.version + `client/local-dev-only-login-as-user/${this.vueOverrideLoginCliNumInput}`);
        if( response.data && response.data.results && response.data.results.successfully_logged_in){
          this.vueOverrideLoginCliNumResult = `successfully logged in in as ${response.data.results.successfully_logged_in}, reloading page`;
          window.document.location = "/spa/vehicle/new";
        } else if( response.data.results.errors ){
          this.vueOverrideLoginCliNumResult = response.data.errors;
        }
        // console.log(response);
      } catch (e) {
        console.error(`Something went wrong with vueDevForceUserLogin`, e);
      }
    },
    async vueDevForceUserLogout(){
      try {
        const response = await axios.get(api.url + api.version + `client/local-dev-only-force-logout`);
        if( response.data && response.data.results && response.data.results.successfully_logged_out){
          this.vueOverrideLoginCliNumResult = `successfully logged out`;
          window.document.location = "/spa/vehicle/new";
        } else if( response.data.results.errors ){
          this.vueOverrideLoginCliNumResult = response.data.errors;
        }
        // console.log(response);
      } catch (e) {
        console.error(`Something went wrong with vueDevForceUserLogout`, e);
      }
    }
  },
  mounted () {
    this.$store.dispatch('getSchema', 'new/vehicle-plate' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })
  }
}

</script>

<style scoped lang="scss">
::v-deep {

}

.recaptcha-wrapper {
  margin-top: 30px;
}

.tc-box {
  padding: 2rem;
  border: 1px solid $light-grey;
  margin: 2rem 0;
  background: $lighter-grey;

  h2 {
    font-size: 16px;
    font-weight: bold;
    margin-top: 0;
  }
  h2 + p {
    padding-bottom: 28px;
  }
  h3 {
    font-size: 16px;
    font-weight: normal;
    position: relative;
    &:before {
      content: '';
      width: 100%;
      border-top: 1px solid $light-grey;
      position: absolute;
      top: -26px;
    }
  }
  ul {
    padding-bottom: 32px;
    font-size: 14px;
  }

  p:last-child {
    padding-bottom: 24px;
    padding-top: 6px;
    position: relative;
    &:before {
      content: '';
      width: 100%;
      border-top: 1px solid $light-grey;
      position: absolute;
      top: -22px;
    }
  }
}
</style>

<style lang="scss">

  input {
    &[name=vehicle_plate] {
      max-width:50%;
    }
  }

  @include mobile() {
    input[name=vehicle_plate] {
      max-width: 100%;
    }
  }
</style>
